import EffectMod from "@/roc/effects/EffectMod";
import { Calc } from "@/roc/effects/EffectAmount";
class SynergyMod extends EffectMod {
    constructor(amount) {
        super(Calc.flat, Math.round(amount));
    }
    apply(value) {
        return value + this.__amount;
    }
}
export default SynergyMod;
